import { INTERP } from './CommonConstants';

const ScoreInterpretationMapper = {
    [INTERP.RED]: 'Well Below',
    [INTERP.YELLOW]: 'Below',
    [INTERP.GREEN]: 'Benchmark',
    [INTERP.GREEN_AT_ABOVE]: 'Benchmark',
    [INTERP.BLUE]: 'Above',
    [INTERP.BELOW]: 'Below',
    [INTERP.PROFICIENT]: 'Proficient',
    [INTERP.PASS]: 'Pass',
    [INTERP.NO_PASS]: 'No Pass',
};

export default ScoreInterpretationMapper;
